export enum ListType {
  BuiltIn = 0,
  SQL = 1
}
